import React from 'react';

export default function Favorites() {
  return (
    <div>
      <h1>Favorites</h1>
    </div>
  );
}
